"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoTriangle = exports.LogoText = exports.LogoMark = exports.Logo = void 0;
var logo_1 = require("./logo");
Object.defineProperty(exports, "Logo", { enumerable: true, get: function () { return __importDefault(logo_1).default; } });
var logo_mark_1 = require("./logo.mark");
Object.defineProperty(exports, "LogoMark", { enumerable: true, get: function () { return __importDefault(logo_mark_1).default; } });
var logo_text_1 = require("./logo.text");
Object.defineProperty(exports, "LogoText", { enumerable: true, get: function () { return __importDefault(logo_text_1).default; } });
var logo_triangle_1 = require("./logo.triangle");
Object.defineProperty(exports, "LogoTriangle", { enumerable: true, get: function () { return __importDefault(logo_triangle_1).default; } });
//# sourceMappingURL=index.js.map